module.exports = __webpack_public_path__ + "media/images/icon_arrow_black-8c014e2ac5d87a067b469d826929fd43.png";